export const Services = () => {
    return (
        <section id="services" className="py-5 bg-light">
            <div className="container text-center">
                <h2 className="fw-bold mb-4">Our Services</h2>
                <div className="row">
                    <div className="col-md-4 mb-4">
                        <div className="card h-100 shadow-sm">
                            <img src="https://www.intermtnwindandsolar.com/wp-content/uploads/2019/04/How-solar-energy-is-created.jpg" className="card-img-top" alt="Residential Solar" />
                            <div className="card-body">
                                <h5 className="card-title">Residential Solar</h5>
                                <p className="card-text">Power your home sustainably with our high-efficiency rooftop solar panels.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="card h-100 shadow-sm">
                            <img src="https://plus.unsplash.com/premium_photo-1663011142797-5bc8250bf401?fm=jpg&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8cm9vZnRvcCUyMHNvbGFyfGVufDB8fDB8fHww&ixlib=rb-4.1.0&q=60&w=3000" className="card-img-top" alt="Commercial Solar" />
                            <div className="card-body">
                                <h5 className="card-title">Commercial Solutions</h5>
                                <p className="card-text">Empower your business with scalable, reliable solar energy systems.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="card h-100 shadow-sm">
                            <img src="https://plus.unsplash.com/premium_photo-1682148014710-095131cd99a8?fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE0fHx8ZW58MHx8fHx8&ixlib=rb-4.1.0&q=60&w=3000" className="card-img-top" alt="Maintenance" />
                            <div className="card-body">
                                <h5 className="card-title">Maintenance & Support</h5>
                                <p className="card-text">We offer ongoing monitoring, cleaning, and repair for maximum performance.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}